import React from 'react';
import { connect } from 'react-redux';
import textRemoveTags from 'service_modules/utils/text-remove-tags';
import dtmEvents from 'service_modules/models/dtm-tagging';
import { Size, Modal } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import AmazonDisclaimer from '../AmazonDisclaimer';

import styles from './index.scss?modules';

const AmazonModal = ({
  header,
  description,
  button,
  cancelButton,
  showApplyNow,
  closeApplyNow
}) => {
  return (
    <Modal.Container $isOpen={showApplyNow} $size={Size.MD} $originHeight={255}>
      <div className={styles.modalBox}>
        <Sanitizer
          className={styles.title}
          role="alert"
          aria-label={`${textRemoveTags(header)} ${textRemoveTags(description)}`}
          safelySetInnerHTML={header || ''}
        />
        <div className={styles.message}>{description}</div>
        <AmazonDisclaimer isAmazonModal={true} />
        <div className={styles.modalButtonContainer}>
          <button
            className={styles.cancelButton}
            onClick={() => closeApplyNow(cancelButton)}
          >
            {cancelButton?.title}
          </button>
          <a
            tabIndex="-1"
            href={button?.url}
            id={button?.id}
            className={styles.continueButton}
            onClick={() =>
              dtmEvents.dispatch({ type: 'DTM_CLICK', dtmTag: button.dtmTag })
            }
          >
            {button?.title}
          </a>
        </div>
      </div>
    </Modal.Container>
  );
};

const mapStateToProps = state => ({
  ...state.modalData
});

export default connect(mapStateToProps)(AmazonModal);
